/* eslint-disable jsx-a11y/alt-text */
import { findCiv } from '../helpers/drafting';
import classNames from 'classnames';

export function DraftCiv({civ, state, randomized, status, result}) {
    const selectedCiv = findCiv(civ, { withFallback: true });

    const hasWon = result === 'won';
    const hasLost = result === 'lost';
    const wasSniped = result === 'sniped';
    const hasPlayed = hasWon || hasLost;
    const hasPicked = result === 'picked';

    return (
        <div className="draft__civContainer">
            <img className={classNames(
                'draft__civOption',
                `draft__civ__${state}`,
                hasWon && 'draft__civWon',
                hasLost && 'draft__civLoss',
                wasSniped && 'draft__civSniped',
                hasPlayed && 'draft__civPlayed',
                hasPicked && 'draft__civPicked'
                )} src={selectedCiv.draftFlagUrl} />
            {state === 'ban' && <img className='draft__civBannedIcon' src="/civBanned.png" />}
            {hasWon && <img className='draft__civWonIcon' src="/civWon.svg" />}
            {hasLost && <img className='draft__civLostIcon' src="/civLost.svg" />}
            {wasSniped && <img className='draft__civSnipedIcon' src="/civSniped.png" />}
            {randomized && <img className={classNames('draft__civRandomIcon', hasPlayed && 'draft__civPlayed')} src="/random.png" />}
            <div className={classNames(
                'draft__civOverlay',
                `draft__civOverlay__${state}`
            )} />
        </div>
    )
}
